import { InputTasksItem } from './inputtasksitem';

export class InputTasks {
  hasNext: boolean;
  items: Array<InputTasksItem>;
  total: number;
}
